export default "__VITE_ASSET__Bb0pFr88__"